import React from "react"
import { withFormik } from "formik"
import { string, object } from "yup"

import styles from "./SignUpForms.module.scss"
import Input from "../../components/Input/Input"
import Dropdown from "../../components/Dropdown/Dropdown"
import { isHaveBadWords } from "../../helpers/badWords"
import { options as industryOptions } from "../../components/filters/MemberSearchFilter/wrappers/IndustryDropdown/options"
import { options as professionOptions } from "../../components/filters/MemberSearchFilter/wrappers/ProfessionDropdown/options"

const IndividualStep2QuestionnaireForm = ({
  values,
  errors,
  handleSubmit,
  handleChange,
  handleBlur,
  touched,
  isSubmitting,
  setFieldValue,
}) => {
  return (
    <form className={styles.form} onSubmit={handleSubmit} id="formikForm">
      <div className={styles.formFields}>
        <Input
          name="firstName"
          className={styles.field}
          placeholder="First Name"
          label="First Name"
          value={values.firstName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.firstName && touched.firstName}
          errorMessage={
            errors.firstName && touched.firstName && errors.firstName
          }
          disabled={true}
        />
        <Input
          name="lastName"
          className={styles.field}
          placeholder="Last Name"
          label="Last Name"
          value={values.lastName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.lastName && touched.lastName}
          errorMessage={
            errors.lastName && touched.lastName && errors.lastName
          }
          disabled={true}
        />
        <Input
          name="email"
          type="email"
          className={styles.field}
          placeholder="Email Address"
          label="Email Address"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.email && touched.email}
          errorMessage={errors.email && touched.email && errors.email}
          disabled={true}
        />
        <Input
          name="companyName"
          className={styles.field}
          placeholder="Company Name"
          label="Company Name"
          value={values.companyName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.companyName && touched.companyName}
          errorMessage={
            errors.companyName && touched.companyName && errors.companyName
          }
          disabled={true}
        />
        <Dropdown
          id="industry"
          name="industry"
          label="Industry"
          placeholder="Industry"
          className={styles.dropdownField}
          fieldStyle="dark"
          value={values.industry || {}}
          options={industryOptions.filter(opt => opt.id !== "")}
          onChange={(name, option) => {
            setFieldValue(name, option)
          }}
          onBlur={handleBlur}
          error={errors.industry && touched.industry}
          errorMessage={
            errors.industry && touched.industry && errors.industry
          }
        />
        <Dropdown
          id="profession"
          name="profession"
          label="Profession"
          placeholder="Profession"
          className={styles.dropdownField}
          fieldStyle="dark"
          value={values.profession || {}}
          options={professionOptions.filter(opt => opt.id !== "")}
          onChange={(name, option) => {
            setFieldValue(name, option)
          }}
          onBlur={handleBlur}
          error={errors.profession && touched.profession}
          errorMessage={
            errors.profession && touched.profession && errors.profession
          }
        />
      </div>
      <button disabled={isSubmitting} style={{ display: "none" }} type="submit">
        Submit form
      </button>
    </form>
  )
}

const FormikApp = withFormik({
  mapPropsToValues(props) {
    return {
      firstName: props.initialValues?.firstName || "",
      lastName: props.initialValues?.lastName || "",
      email: props.initialValues?.email || "",
      companyName: props.initialValues?.companyName || "",
      industry: props.initialValues?.industry || {},
      profession: props.initialValues?.profession || {},
    }
  },
  validationSchema: () =>
    object().shape({
      firstName: string()
        .trim()
        .matches(
          /^[a-zA-Z\s_\-_'_"]*$/,
          "Enter a correct First Name that doesn't contain any special characters or numbers",
        )
        .matches(/[^\\s*]+/, "Please enter first name")
        .min(2, "Please enter a correct first name that consists of a minimum 2 characters")
        .max(32, "Please enter a correct first name that consists of no more than 32 characters")
        .test({
          name: "description_obj",
          test: (val) => {
            if (!val) return true
            if (val) {
              return !isHaveBadWords(val)
            }
          },
          message: `Please don't use bad language`,
        })
        .required("Please enter first name"),
      lastName: string()
        .trim()
        .matches(
          /^[a-zA-Z\s_\-_'_"]*$/,
          "Enter a correct Last Name that doesn't contain any special characters or numbers",
        )
        .matches(/[^\\s*]+/, "Please enter last name")
        .min(2, "Please enter a correct last name that consists of a minimum 2 characters")
        .max(32, "Please enter a correct last name that consists of no more than 32 characters")
        .test({
          name: "description_obj",
          test: (val) => {
            if (!val) return true
            if (val) {
              return !isHaveBadWords(val)
            }
          },
          message: `Please don't use bad language`,
        })
        .required("Please enter last name"),
      email: string()
        .email("Please enter your email address in format yourname@example.com")
        .max(64, "Please enter a valid email address that consists of no more than 64 characters")
        .required("Please enter email address"),
      companyName: string()
        .trim()
        .min(2, "Please enter a correct company name that consists of a minimum 2 characters")
        .max(64, "Please enter a correct company name that consists of no more than 64 characters")
        .test({
          name: "description_obj",
          test: (val) => {
            if (!val) return true
            if (val) {
              return !isHaveBadWords(val)
            }
          },
          message: `Please don't use bad language`,
        })
        .required("Please enter company name"),
      industry: object()
        .test("required", "Please select industry", (value) => {
          return value && value.id && value.id !== "default"
        }),
      profession: object()
        .test("required", "Please select profession", (value) => {
          return value && value.id && value.id !== "default"
        }),
    }),
  handleSubmit(values, { setSubmitting, props: { handleSaveQuestionnaire } }) {
    setSubmitting(true)
    handleSaveQuestionnaire(values)
      .then(() => {
        setSubmitting(false)
      })
      .catch((error) => {
        setSubmitting(false)
        console.error("Error saving questionnaire:", error)
      })
  },
})(IndividualStep2QuestionnaireForm)

export default FormikApp

